import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateForm,
  updateAuthForm,
  clearForm,
} from "../../redux/slice/loginSlice";
import { RootState } from "../../redux/Store";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import "./LoginPage.css";
import Loader from "../../common/Loader";
import {
  ChangePassword,
  ValidateUser,
  ValidateMFACode,
  ResendMFACode,
  ForgotPassword,
} from "../../services/AuthService";
import { Navigate, useNavigate } from "react-router-dom";
import * as Constants from "./LoginPageConstant";

const carouselData = [
  {
    image: require("../../modules/login/LoginImage/banner1.png"),
    title: Constants.carouselData[0].title,
    text: Constants.carouselData[0].text,
  },
  {
    image: require("../../modules/login/LoginImage/banner1.png"),
    title: Constants.carouselData[1].title,
    text: Constants.carouselData[1].text,
  },
  {
    image: require("../../modules/login/LoginImage/banner1.png"),
    title: Constants.carouselData[2].title,
    text: Constants.carouselData[2].text,
  },
];

const LoginPage: React.FC<any> = ({ deviceId, deviceName, onLoginSuccess }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [messageType, setMessageType] = useState<string>("error");

  const { name: username, Pass: password } = useSelector(
    (state: RootState) => state.form,
  );
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [otp, setOtp] = useState<string>("");
  const [currentPassword, setCurrentPassword] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [showOTP, setShowOTP] = useState<boolean>(false);
  const [timer, setTimer] = useState<number>(Constants.TIMER_DURATION);
  const [showResend, setShowResend] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [validationMessage, setValidationMessage] = useState<string>("");
  const [isMFA, setIsMFA] = useState<boolean>(false);
  const [isSignIn, setIsSignIn] = useState<boolean>(false);
  const [isfirsttimelogin, setisfirsttimelogin] = useState<boolean>(false);
  const [userId, setuserId] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [reasonCode, setReasonCode] = useState<number>(0);
  const [showCurrentPassword, setShowCurrentPassword] =
    useState<boolean>(false);
  const [showNewPassword, setShowNewPassword] = useState<boolean>(false);
  const [showContinueButton, setshowContinueButton] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] =
    useState<boolean>(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselData.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let countdown: NodeJS.Timeout | null = null;

    if (isMFA && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    if (timer === 0) {
      setShowResend(true);
    }

    return () => {
      if (countdown) clearInterval(countdown);
    };
  }, [isMFA, timer]);

  useEffect(() => {
    if (validationMessage) {
      const timer = setTimeout(() => {
        setValidationMessage("");
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [validationMessage]);

  const handleIndicatorClick = (index: number) => {
    setCurrentIndex(index);
  };

  const handleLogin = async () => {
    const validationMessages: string[] = [];

    if (!username) {
      validationMessages.push(Constants.upCriteria.username);
    }
    if (!password) {
      validationMessages.push(Constants.upCriteria.password);
    }
    if (validationMessages.length > 0) {
      setValidationMessage(validationMessages.join(" "));
      return;
    }
    try {
      setLoading(true);
      const response = await ValidateUser({
        userName: username,
        password: password,
        deviceId: deviceId,
        deviceName: deviceName,
      });
      if (response.result != null) {
        setuserId(response.result.userid);
      }
      if (response.statusCode == "8" || response.statusCode == "7") {
        setValidationMessage(Constants.validationMessages.invalidCredentials);
        setMessageType("error");
      } else if (response.statusCode == "5") {
        setValidationMessage(Constants.validationMessages.notAuthorized);
        setMessageType("error");
      } else if (response.statusCode == "1") {
        setValidationMessage(
          Constants.validationMessages.accountVerificationPending,
        );
        setMessageType("error");
      } else if (response.statusCode == "6") {
        setValidationMessage(Constants.validationMessages.accountInactive);
        setMessageType("error");
      } else if (response.statusCode == "11") {
        setValidationMessage(Constants.validationMessages.accountLocked);
        setMessageType("error");
      } else if (response.statusCode == "10") {
        setIsMFA(true);
        setisfirsttimelogin(false);
      } else if (
        response.statusCode == "2" ||
        response.statusCode == "3" ||
        response.statusCode == "4"
      ) {
        setisfirsttimelogin(true);
        setMessageType("error");
        setReasonCode(Number(response.statusCode));
      } else if (response.statusCode == "9" || response.statusCode == "15") {
        setTimeout(() => {
          setValidationMessage(Constants.validationMessages.loginSuccess);
          setMessageType("success");
        }, 5000);

        dispatch(
          updateAuthForm({
            username,
            token: response.result.tokenValue,
            emailid: response.result.emailid || "",
            userid: response.result.userid || null,
            isSuccessful: true,
          }),
        );

        onLoginSuccess({
          username,
          token: response.result.tokenValue,
          emailid: response.result.emailid || "",
          userid: response.result.userid || 0,
          isSuccessful: true,
          firstname: response.result.firstname,
          lastname: response.result.lastname,
          userroledescription: response.result.currentAppRoleDesc,
        });
      }
    } catch (error) {
      setValidationMessage("An unexpected error occurred.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const validateOTPCode = async () => {
    if (!otp) {
      setValidationMessage(Constants.validationMessages.enterOtp);
      setMessageType("error");
      return;
    }

    setLoading(true); // Assuming you have a loading state for this process.

    try {
      const response = await ValidateMFACode({
        UserId: userId,
        deviceId: deviceId,
        deviceName: deviceName,
        MFACode: otp,
      });

      if (response.isSuccess) {
        if (response.statusCode == "12") {
          setValidationMessage(Constants.validationMessages.correctOtp);
          setMessageType("error");
        } else if (response.statusCode == "11") {
          setValidationMessage(response.message);
        } else if (response.statusCode == "14") {
          setTimeout(() => {
            setValidationMessage(Constants.validationMessages.loginSuccess);
            setMessageType("success");
          }, 5000);

          dispatch(
            updateAuthForm({
              username,
              token: response.result.tokenValue,
              emailid: response.result.emailid || "",
              userid: response.result.userid || null,
              isSuccessful: true,
            }),
          );

          onLoginSuccess({
            username,
            token: response.result.tokenValue,
            emailid: response.result.emailid || "",
            userid: response.result.userid || 0,
            isSuccessful: true,
            firstname: response.result.firstname,
            lastname: response.result.lastname,
            userroledescription: response.result.userroledescription,
          });
        }
      } else {
        setValidationMessage(Constants.validationMessages.correctOtp);
        setMessageType("error");
        return;
      }
    } catch (error) {
      setValidationMessage("An unexpected error occurred.");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = async () => {
    setShowResend(false);
    setOtp("");
    setTimer(Constants.TIMER_DURATION);
    const response = await ResendMFACode({
      Userid: userId,
      deviceId: deviceId,
      deviceName: deviceName,
    });
  };

  const handlePasswordUpdate = async () => {
    const validationMessages: string[] = [];
    const passwordCriteriaRegex =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\W_]{8,}$/;

    // Validate current password
    if (!currentPassword) {
      validationMessages.push(Constants.validationMessages.currentPassword);
      setMessageType("error");
    }

    // Validate new password
    if (!newPassword) {
      validationMessages.push(Constants.validationMessages.newPassword);
      setMessageType("error");
    } else if (!passwordCriteriaRegex.test(newPassword)) {
      validationMessages.push(Constants.validationMessages.passwordError);
      setMessageType("error");
    }

    // Validate confirm password
    if (!confirmPassword) {
      validationMessages.push(Constants.validationMessages.confirmpassword);
      setMessageType("error");
    } else if (newPassword !== confirmPassword) {
      validationMessages.push(Constants.validationMessages.passwordMismatch);
      setMessageType("error");
    }

    if (validationMessages.length > 0) {
      setValidationMessage(validationMessages.join(" "));
      return;
    }

    setLoading(true); // Assuming you have a loading state

    try {
      const response = await ChangePassword({
        Userid: userId,
        OldPassword: currentPassword,
        NewPassword: newPassword,
        ReasonCode: reasonCode,
      });
      if (response.statusCode == "1") {
        setisfirsttimelogin(false);
        setValidationMessage(Constants.validationMessages.passwordChanged);
        setShowForgotPassword(false);
        dispatch(clearForm());
        setMessageType("success");
        return;
      } else if (response.statusCode == "2") {
        setValidationMessage(Constants.validationMessages.invalidUser);
        setMessageType("error");
        return;
      } else if (response.statusCode == "3") {
        setValidationMessage(
          Constants.validationMessages.currentPasswordMismatch,
        );
        setMessageType("error");
        return;
      } else if (response.statusCode == "4") {
        setValidationMessage(
          Constants.validationMessages.currentNewPasswordSame,
        );
        setMessageType("error");
        return;
      } else if (response.statusCode == "5") {
        setValidationMessage(Constants.validationMessages.reusedPassword);
        setMessageType("error");
        return;
      }
    } catch (error) {
      setValidationMessage(
        "An unexpected error occurred while processing your request.",
      );
      setMessageType("error");
    } finally {
      setLoading(false); // Ensure the loading state is reset
    }
  };

  const handleForgotPassword = async () => {
    if (!email.trim()) {
      setValidationMessage(Constants.validationMessages.enterEmail);
      setMessageType("error");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setValidationMessage(Constants.validationMessages.validEmail);
      setMessageType("error");
      return;
    }

    try {
      setLoading(true);
      const response = await ForgotPassword(email);

      if (response.isSuccess) {
        if (response.result.responseCode == "1") {
          setValidationMessage(Constants.validationMessages.emailFound);
          setMessageType("success");
          setshowContinueButton(true);
        } else {
          setValidationMessage(Constants.validationMessages.emailNotFound);
          setMessageType("error");
        }
      }
    } catch (error) {
      setValidationMessage("Something went wrong. Please try again.");
      setMessageType("error");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field: "name" | "Pass", value: string) =>
    dispatch(updateForm({ [field]: value }));

  return (
    <div className="h-100">
      <Loader isLoading={loading} />
      {validationMessage && (
        <div
          className={`alert d-flex justify-content-between align-items-start mx-auto ${
            messageType === "success" ? "alert-success" : "alert-danger"
          }`}
        >
          <div className="me-auto">
            <div>
              {validationMessage.split("\n").map((msg, index) => (
                <span key={index} style={{ display: "block" }}>
                  {msg}
                </span>
              ))}
            </div>
          </div>
          <button
            type="button"
            className="btn-close bg-dark ms-3 p-1"
            aria-label="Close"
            onClick={() => setValidationMessage("")}
          >
            <span className="material-icons">close</span>
          </button>
        </div>
      )}

      <div className="d-flex h-100">
        <div className="carousel flex-fill  d-flex align-items-top justify-content-center">
          <img
            id="carouselImage"
            src={carouselData[currentIndex].image}
            alt="Carousel"
            className="w-65"
          />
          <h2 id="carouselTitle">{carouselData[currentIndex].title}</h2>
          <p id="carouselText">{carouselData[currentIndex].text}</p>
          <div className="indicators my-3">
            {carouselData.map((_, index) => (
              <div
                key={index}
                className={`indicator ${
                  currentIndex === index ? "active" : ""
                }`}
                onClick={() => handleIndicatorClick(index)}
              ></div>
            ))}
          </div>
          <p className="copyright">{Constants.footerText}</p>
        </div>

        <div className="login-container flex-fill  d-flex align-items-center justify-content-center">
          <div className="border col-md-8 col-xl-7 col-xxl-6 px-4 py-3 d-flex flex-column loginContainer">
            <div className="text-center mx-auto">
              <img
                id="loginLogo"
                src={require("../../modules/login/LoginImage/loginLogo.png")}
                alt="Logo"
              />
              <img
                id="carouselImage"
                src={carouselData[currentIndex].image}
                alt="Carousel"
                className="w-65 carousel-main-image my-4"
              />
            </div>

            <form>
              {!showForgotPassword ? (
                !isfirsttimelogin ? (
                  <>
                    <div className="form-floating mb-1 login_input">
                      <input
                        type="text"
                        className="form-control"
                        id="username"
                        placeholder="User Name"
                        value={username}
                        onChange={(e) =>
                          handleInputChange("name", e.target.value.trim())
                        } // Trims spaces
                        onBlur={(e) =>
                          handleInputChange("name", e.target.value.trim())
                        } // Trims when focus is lost
                        maxLength={50}
                      />
                      <label htmlFor="username">User Name</label>
                    </div>

                    <div className="form-floating mb-1 password-container login_input">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        id="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) =>
                          handleInputChange("Pass", e.target.value.trim())
                        } // Trims spaces
                        onBlur={(e) =>
                          handleInputChange("Pass", e.target.value.trim())
                        } // Trims when focus is lost
                        maxLength={30}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleLogin();
                          }
                        }}
                      />
                      <label htmlFor="password">Password</label>
                      <span
                        className="toggle-password"
                        onClick={() => setShowPassword((prev) => !prev)}
                      >
                        {showPassword ? (
                          <span className="material-icons">visibility</span>
                        ) : (
                          <span className="material-icons">visibility_off</span>
                        )}
                      </span>
                    </div>
                    <div className="text-end mt-2">
                      <a
                        href="#"
                        className="forgot-password-link"
                        onClick={(e) => {
                          e.preventDefault(); // Prevents default navigation
                          setShowForgotPassword(true);
                          setshowContinueButton(false);
                          setEmail("");
                        }}
                      >
                        Forgot Password?
                      </a>
                    </div>

                    <div className="text-center my-5">
                      <button
                        type="button"
                        className="btn btn-primary signIn"
                        onClick={handleLogin}
                        disabled={isMFA}
                      >
                        Sign In
                      </button>
                    </div>

                    {isMFA && (
                      <>
                        <div className="d-flex align-items-end justify-content-between">
                          <div className="form-floating mb-1 w-50 mt-1">
                            <input
                              type="text"
                              className="form-control"
                              id="otp"
                              placeholder="Enter OTP"
                              value={otp}
                              maxLength={6}
                              onChange={(e) => setOtp(e.target.value)}
                            />
                            <label htmlFor="otp">Enter OTP</label>
                          </div>
                          <div className="mx-3 text-center countdown">
                            <span>{timer}s</span>
                          </div>
                          <div>
                            {!showResend ? (
                              <button
                                type="button"
                                className="btn btn-primary border-btn"
                                onClick={validateOTPCode}
                              >
                                Submit
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-primary border-btn"
                                onClick={handleResendOTP}
                              >
                                Resend OTP
                              </button>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <div className="changepassword">Change Password</div>
                    <div className="form-floating mb-1">
                      <input
                        type={showCurrentPassword ? "text" : "password"}
                        className="form-control"
                        id="currentPassword"
                        placeholder="Current Password"
                        value={currentPassword}
                        maxLength={30}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                      />
                      <label htmlFor="currentPassword">Current Password</label>
                      <span
                        className="toggle-password"
                        onClick={() => setShowCurrentPassword((prev) => !prev)}
                      >
                        {showCurrentPassword ? (
                          <span className="material-icons">visibility</span>
                        ) : (
                          <span className="material-icons">visibility_off</span>
                        )}
                      </span>
                    </div>
                    <div className="form-floating mb-1">
                      <input
                        type={showNewPassword ? "text" : "password"}
                        className="form-control"
                        id="newPassword"
                        placeholder="New Password"
                        value={newPassword}
                        maxLength={30}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <label htmlFor="newPassword">New Password</label>
                      <span
                        className="toggle-password"
                        onClick={() => setShowNewPassword((prev) => !prev)}
                      >
                        {showNewPassword ? (
                          <span className="material-icons">visibility</span>
                        ) : (
                          <span className="material-icons">visibility_off</span>
                        )}
                      </span>
                    </div>
                    <div className="form-floating mb-3">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="form-control"
                        id="confirmPassword"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        maxLength={30}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <label htmlFor="confirmPassword">Confirm Password</label>
                      <span
                        className="toggle-password"
                        onClick={() => setShowConfirmPassword((prev) => !prev)}
                      >
                        {showConfirmPassword ? (
                          <span className="material-icons">visibility</span>
                        ) : (
                          <span className="material-icons">visibility_off</span>
                        )}
                      </span>
                    </div>
                    <div className="passwordcriteria">
                      <p className="mb-0">Password Must:</p>
                      <ul>
                        <li>Include lower and Upper character</li>
                        <li>Include at least 1 number or symbol</li>
                        <li>Be at least 8 characters long</li>
                        <li>Match in both fields</li>
                      </ul>
                    </div>

                    <div className="text-center">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handlePasswordUpdate}
                      >
                        Submit
                      </button>
                    </div>
                  </>
                )
              ) : (
                <>
                  <h2 className="text-center my-3">Forgot Your Password?</h2>
                  <div className="text-center my-3">
                    Enter your email address and we will send you instruction to
                    reset your password
                  </div>
                  <div className="form-floating mb-1 login_input">
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Enter Email Address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      autoComplete="off"
                    />
                    <label htmlFor="email">Enter Email Address</label>
                  </div>
                  <div className="text-center">
                    <button
                      type="button"
                      className="btn btn-primary mt-3"
                      onClick={() => {
                        handleForgotPassword();
                      }}
                      disabled={showContinueButton}
                    >
                      Continue
                    </button>
                  </div>
                  <div className="text-center mt-2">
                    <a
                      href="#"
                      className="backtologin text-center"
                      onClick={() => setShowForgotPassword(false)}
                    >
                      Back to Login
                    </a>
                  </div>
                </>
              )}
            </form>
            <div className="mt-auto">
              <div className="footer text-center mt-3">
                <p>{Constants.termsAndPolicyText}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
